<template>
  <div class="container welfare-page">
    <div class="welfare-tabs">
      <button v-if="pointsEntryVisible" type="button" :class="{ active: section === 'points' }" @click="navigate('/member/points')">积分中心</button>
      <button type="button" :class="{ active: section === 'vip' }" @click="navigate('/member/vip')">晋级彩金</button>
      <button type="button" :class="{ active: section === 'gift' }" @click="navigate('/member/gift')">晋级豪礼</button>
    </div>

    <div v-if="!isLoggedIn" class="welfare-state">
      <b>请先登录</b>
      <button type="button" @click="openAuth('login')">登录后查看</button>
    </div>
    <div v-else-if="loading" class="welfare-state">正在加载…</div>
    <div v-else-if="error && !pointsCenter && !vipDetail && !giftRule" class="welfare-state error">
      <b>加载失败</b>
      <span>{{ error }}</span>
      <button type="button" @click="loadSection">重新获取</button>
    </div>

    <template v-else-if="section === 'points' && pointsCenter">
      <section class="welfare-hero">
        <img v-if="pointsCenter.iconUrl" :src="pointsCenter.iconUrl" alt="" />
        <div>
          <small>{{ pointsCenter.pointsName || '积分' }}</small>
          <strong>{{ pointsCenter.memberBalance }}</strong>
          <p>当前{{ pointsCenter.pointsName || '积分' }}余额</p>
        </div>
      </section>
      <section v-if="pointsCenter.status !== 1" class="welfare-card">{{ pointsCenter.pauseMessage || '积分中心暂未开放' }}</section>
      <section v-else-if="pointsCenter.memberPointsStatus === 2" class="welfare-card">{{ pointsCenter.memberFreezePrompt || '您的积分账户已冻结' }}</section>
      <template v-else>
        <section class="welfare-card">
          <h2>积分任务</h2>
          <p v-if="!pointsCenter.tasks.length">暂无进行中的积分任务</p>
          <article v-for="task in pointsCenter.tasks" :key="task.id" class="welfare-task">
            <img v-if="task.iconUrl" :src="task.iconUrl" alt="" />
            <div>
              <b>{{ task.title }} <i>{{ task.taskTypeName }}</i></b>
              <span>{{ task.subtitle }}</span>
              <small>{{ task.releaseRule }}</small>
              <small v-if="task.description">{{ task.description }}</small>
            </div>
          </article>
        </section>
        <section class="welfare-card">
          <h2>待领取积分</h2>
          <p v-if="!rewards.length">暂无待领取积分</p>
          <article v-for="reward in rewards" :key="reward.transactionNo" class="welfare-reward">
            <div>
              <b>{{ reward.points }} {{ pointsCenter.pointsName || '积分' }}</b>
              <small>{{ reward.remark || '任务奖励' }}</small>
              <small>流水号：{{ reward.transactionNo }}</small>
            </div>
            <button type="button" class="primary" :disabled="Boolean(claimingNo)" @click="claimReward(reward)">
              {{ claimingNo === reward.transactionNo ? '领取中' : '领取' }}
            </button>
          </article>
          <button v-if="rewards.length < rewardTotal" type="button" class="welfare-more" :disabled="loadingMore || Boolean(claimingNo)" @click="loadMoreRewards">
            {{ loadingMore ? '加载中…' : '加载更多' }}
          </button>
          <p v-if="error" class="welfare-error">{{ error }}</p>
        </section>
        <section v-if="pointsRules" class="welfare-card">
          <h2>积分规则</h2>
          <div class="help-rich-text" v-html="pointsRules"></div>
        </section>
      </template>
    </template>

    <template v-else-if="section === 'vip' && vipDetail">
      <section class="welfare-hero">
        <div>
          <small>{{ vipDetail.levelName || 'VIP' }}</small>
          <strong>晋级进度 {{ vipDetail.progressRate || '0' }}%</strong>
          <p>存款 {{ vipDetail.currentDeposit || '0.00' }} · 流水 {{ vipDetail.currentTurnover || '0.00' }}</p>
        </div>
      </section>
      <section class="welfare-card">
        <h2>选择等级</h2>
        <div v-if="promotionRules.length" class="welfare-levels">
          <button
            v-for="rule in promotionRules"
            :key="rule.memberLevelId"
            type="button"
            :class="{ active: rule.memberLevelId === selectedLevelId }"
            @click="selectPromotionLevel(rule.memberLevelId)"
          >
            {{ (vipDetail.levels || []).find(item => item.levelId === rule.memberLevelId)?.levelName || `等级${rule.memberLevelId}` }}
          </button>
        </div>
        <p v-else>暂无晋级彩金规则</p>
        <div v-if="selectedRule" class="welfare-metrics">
          <article v-for="item in promotionMetrics" :key="item.label">
            <b>{{ item.value }}</b>
            <span>{{ item.label }}</span>
          </article>
        </div>
        <form v-if="selectedRule" class="welfare-form" @submit.prevent="claimVipPromotion">
          <label>选择场馆
            <select v-model.number="selectedVenueId" required>
              <option :value="0" disabled>请选择场馆</option>
              <option v-for="venue in selectedRule.participatingVenues" :key="venue.venueId" :value="venue.venueId">{{ venue.venueName }}</option>
            </select>
          </label>
          <label>转入金额
            <input data-decimal-input="2" v-model="transferAmount" inputmode="decimal" :placeholder="`最低${selectedRule.minimumTransferAmount || '0'}`" />
          </label>
          <button class="primary" type="submit" :disabled="!canClaimPromotion">{{ claimButtonText }}</button>
          <p v-if="error" class="welfare-error">{{ error }}</p>
        </form>
      </section>
      <VipBonusHistory :refresh-key="bonusRefreshKey" />
      <section class="welfare-card" aria-label="VIP活动规则">
        <h2>活动规则</h2>
        <p v-if="vipActivityRulesError" class="welfare-error">{{ vipActivityRulesError }}</p>
        <p v-else-if="!vipActivityRules.length">暂无VIP活动规则</p>
        <div v-else class="help-rich-text">
          <div v-for="(rule, index) in vipActivityRules" :key="`${rule.sortNo}-${index}`" v-html="sanitizeHelpContent(rule.content)"></div>
        </div>
      </section>
    </template>

    <template v-else-if="section === 'gift' && giftRule">
      <section class="welfare-hero">
        <img v-if="giftRule.rewardImageUrl" :src="giftRule.rewardImageUrl" alt="" />
        <div>
          <small>{{ giftRule.memberLevelName || '晋级豪礼' }}</small>
          <strong>{{ giftRule.rewardNames?.join(' + ') || '晋级豪礼' }}</strong>
          <p v-if="giftRule.applied === 1">{{ giftStatusText[giftRule.applicationStatus] || '已申请' }}</p>
          <p v-else-if="giftRule.enabled !== 1">活动未开放</p>
          <p v-else-if="giftRule.eligible !== 1">当前暂不可申请</p>
          <p v-else>提交后由后台审核、发货并完成入账</p>
        </div>
      </section>
      <section v-if="giftRule.applied === 1" class="welfare-card">
        <h2>申请进度</h2>
        <p>状态：{{ giftStatusText[giftRule.applicationStatus] || giftRule.applicationStatus || '已申请' }}</p>
        <p v-if="giftRule.logisticsCompany || giftRule.trackingNo">物流：{{ giftRule.logisticsCompany || '物流公司待更新' }} {{ giftRule.trackingNo }}</p>
      </section>
      <form v-else-if="giftRule.enabled === 1 && giftRule.eligible === 1" class="welfare-card welfare-form" @submit.prevent="applyGift">
        <h2>收货信息</h2>
        <label>收货人
          <input v-model.trim="receipt.receiverName" maxlength="100" placeholder="请输入收货人姓名" />
        </label>
        <label>手机号
          <input v-model.trim="receipt.phone" maxlength="30" placeholder="请输入收货人手机号" />
        </label>
        <label>收货地址
          <textarea v-model.trim="receipt.address" maxlength="500" rows="3" placeholder="请输入详细收货地址"></textarea>
        </label>
        <button class="primary" type="submit" :disabled="!canApplyGift">{{ giftButtonText }}</button>
        <p v-if="error" class="welfare-error">{{ error }}</p>
      </form>
    </template>
  </div>
</template>

<script setup>
import { isDecimalAmount } from '../../utils/decimalInput.mjs'
import { computed, ref, watch } from 'vue'
import { useAppContext } from '../../composables/appContext'
import { webApi } from '../../services/webApi'
import { readVipActivityRules } from '../../services/vipActivityRules'
import VipBonusHistory from './VipBonusHistory.vue'

const { currentPath, isLoggedIn, navigate, notify, openAuth, sanitizeHelpContent, pointsEntryVisible, loadPointsEntry } = useAppContext()
let loadRequestId = 0

const section = computed(() => {
  if (currentPath.value === '/member/points') return 'points'
  if (currentPath.value === '/member/vip') return 'vip'
  if (currentPath.value === '/member/gift') return 'gift'
  return ''
})

const loading = ref(false)
const error = ref('')
const submitting = ref(false)

const pointsCenter = ref(null)
const rewards = ref([])
const rewardTotal = ref(0)
const rewardPage = ref(1)
const loadingMore = ref(false)
const claimingNo = ref('')

const vipDetail = ref(null)
const promotionRules = ref([])
const selectedLevelId = ref(0)
const selectedVenueId = ref(0)
const transferAmount = ref('')
const bonusRefreshKey = ref(0)

const giftRule = ref(null)
const receipt = ref({ receiverName: '', phone: '', address: '' })

const cycleText = { 1: '仅1次', 2: '每日1次', 3: '每周1次', 4: '每月1次' }
const giftStatusText = { PENDING: '待发货', SHIPPED: '已发货', COMPLETED: '已完成' }

const vipActivityRulesState = computed(() => {
  try { return { rows: readVipActivityRules(vipDetail.value?.rules), error: '' } }
  catch (ruleError) { return { rows: [], error: ruleError.message || 'VIP活动规则读取失败' } }
})
const vipActivityRules = computed(() => vipActivityRulesState.value.rows)
const vipActivityRulesError = computed(() => vipActivityRulesState.value.error)
const pointsRules = computed(() => sanitizeHelpContent(pointsCenter.value?.rules || ''))
const currentRank = computed(() => {
  const level = (vipDetail.value?.levels || []).find(item => item.levelId === vipDetail.value?.levelId)
  return Number(level?.rankNo || 0)
})
const selectedLevel = computed(() => (vipDetail.value?.levels || []).find(item => item.levelId === selectedLevelId.value))
const selectedRule = computed(() => promotionRules.value.find(item => item.memberLevelId === selectedLevelId.value))
const selectedVenue = computed(() => (selectedRule.value?.participatingVenues || []).find(item => item.venueId === selectedVenueId.value))
const promotionMetrics = computed(() => {
  const rule = selectedRule.value
  return [
    { label: '最低转账', value: rule?.minimumTransferAmount || '--' },
    { label: '红利比例', value: rule ? `${rule.bonusRatio}%` : '--' },
    { label: '最高奖金', value: rule?.bonusCap || '--' },
    { label: '流水倍数', value: rule ? `${rule.turnoverMultiplier}倍` : '--' },
    { label: '次数限制', value: cycleText[rule?.applicationCycle] || '--' },
    { label: '游戏场馆', value: rule?.participatingVenues?.length ? `${rule.participatingVenues.length}个场馆` : '--' },
  ]
})
const canClaimPromotion = computed(() => {
  const rule = selectedRule.value
  const rank = Number(selectedLevel.value?.rankNo || 0)
  return Boolean(
    rule?.enabled === 1
    && rank <= currentRank.value
    && rule.claimed !== 1
    && selectedVenue.value
    && isDecimalAmount(transferAmount.value)
    && Number(transferAmount.value) > 0
    && Number(transferAmount.value) >= Number(rule.minimumTransferAmount || 0)
    && !submitting.value,
  )
})
const claimButtonText = computed(() => {
  const rank = Number(selectedLevel.value?.rankNo || 0)
  if (rank > currentRank.value) return '等级不符'
  if (selectedRule.value?.claimed === 1) return '已领取'
  if (selectedRule.value?.enabled !== 1) return '未开放'
  return submitting.value ? '申请中' : '立即领取'
})
const giftButtonText = computed(() => {
  const rule = giftRule.value
  if (!rule) return '立即申请'
  if (rule.applied === 1) return giftStatusText[rule.applicationStatus] || '已申请'
  if (rule.enabled !== 1) return '未开放'
  if (rule.eligible !== 1) return '暂不可申请'
  return submitting.value ? '提交中' : '提交申请'
})
const canApplyGift = computed(() => {
  const rule = giftRule.value
  return Boolean(
    rule?.enabled === 1
    && rule.eligible === 1
    && rule.applied !== 1
    && rule.memberLevelId
    && receipt.value.receiverName.trim()
    && /^1\d{10}$/.test(receipt.value.phone.trim())
    && receipt.value.address.trim()
    && !submitting.value,
  )
})

function resetWelfare() {
  error.value = ''
  pointsCenter.value = null
  rewards.value = []
  rewardTotal.value = 0
  rewardPage.value = 1
  vipDetail.value = null
  promotionRules.value = []
  selectedLevelId.value = 0
  selectedVenueId.value = 0
  transferAmount.value = ''
  giftRule.value = null
  receipt.value = { receiverName: '', phone: '', address: '' }
}

async function loadPoints() {
  const [center, pending] = await Promise.all([
    loadPointsEntry(),
    webApi.pointsRewards({ pageNumber: 1, pageSize: 10 }),
  ])
  if (!center || !Array.isArray(center.tasks)) throw new Error('积分中心数据异常')
  if (!pending || !Array.isArray(pending.data)) throw new Error('待领取积分数据异常')
  pointsCenter.value = center
  rewards.value = pending.data
  rewardTotal.value = Number(pending.total || 0)
  rewardPage.value = 1
}

async function loadMoreRewards() {
  if (loadingMore.value || claimingNo.value) return
  loadingMore.value = true
  error.value = ''
  try {
    const result = await webApi.pointsRewards({ pageNumber: rewardPage.value + 1, pageSize: 10 })
    if (!result || !Array.isArray(result.data)) throw new Error('待领取积分数据异常')
    rewards.value = [...rewards.value, ...result.data]
    rewardPage.value += 1
    rewardTotal.value = Number(result.total || 0)
  } catch (loadError) {
    error.value = loadError.message || '加载失败，请重试'
  } finally {
    loadingMore.value = false
  }
}

async function claimReward(reward) {
  if (claimingNo.value || loadingMore.value) return
  claimingNo.value = reward.transactionNo
  error.value = ''
  try {
    await webApi.claimPoints({ transactionNo: reward.transactionNo })
    notify('领取成功')
    try {
      await loadPoints()
    } catch {
      pointsCenter.value = null
      rewards.value = []
      rewardTotal.value = 0
      error.value = '领取成功，积分数据刷新失败，请重新加载'
    }
  } catch (claimError) {
    error.value = claimError.message || '领取失败，请重试'
  } finally {
    claimingNo.value = ''
  }
}

async function loadVip() {
  const [detail, rules] = await Promise.all([
    webApi.vipDetail(),
    webApi.vipPromotionRules(),
  ])
  vipDetail.value = detail
  promotionRules.value = Array.isArray(rules?.data) ? rules.data : []
  const current = (detail?.levels || []).find(item => item.levelId === detail?.levelId)
  const matched = promotionRules.value.find(item => item.memberLevelId === current?.levelId) || promotionRules.value[0]
  selectedLevelId.value = matched?.memberLevelId || current?.levelId || 0
  selectedVenueId.value = 0
  transferAmount.value = ''
}

function selectPromotionLevel(levelId) {
  selectedLevelId.value = levelId
  selectedVenueId.value = 0
  transferAmount.value = ''
}

async function claimVipPromotion() {
  if (!canClaimPromotion.value) return
  submitting.value = true
  error.value = ''
  try {
    await webApi.claimVipPromotion({
      memberLevelId: selectedLevelId.value,
      venueId: selectedVenueId.value,
      transferAmount: String(transferAmount.value),
    })
    notify('申请成功')
    bonusRefreshKey.value += 1
    await loadVip()
  } catch (claimError) {
    error.value = claimError.message || '申请失败，请重试'
  } finally {
    submitting.value = false
  }
}

async function loadGift() {
  const [rule, info] = await Promise.all([
    webApi.vipGiftRule(),
    webApi.vipReceiptInfo().catch(() => ({ receiverName: '', phone: '', address: '' })),
  ])
  giftRule.value = rule
  receipt.value = {
    receiverName: info?.receiverName || '',
    phone: info?.phone || '',
    address: info?.address || '',
  }
}

async function applyGift() {
  if (!canApplyGift.value) return
  submitting.value = true
  error.value = ''
  try {
    await webApi.updateVipReceiptInfo({
      receiverName: receipt.value.receiverName.trim(),
      phone: receipt.value.phone.trim(),
      address: receipt.value.address.trim(),
    })
    await webApi.applyVipGift({ memberLevelId: giftRule.value.memberLevelId })
    notify('豪礼申请已提交')
    await loadGift()
  } catch (applyError) {
    error.value = applyError.message || '申请失败，请重试'
  } finally {
    submitting.value = false
  }
}

async function loadSection() {
  if (!section.value) return
  const requestId = ++loadRequestId
  if (!isLoggedIn.value) {
    loading.value = false
    resetWelfare()
    return
  }
  loading.value = true
  error.value = ''
  resetWelfare()
  try {
    if (section.value === 'points') await loadPoints()
    if (section.value === 'vip') await loadVip()
    if (section.value === 'gift') await loadGift()
  } catch (loadError) {
    if (requestId === loadRequestId) error.value = loadError.message || '加载失败，请重试'
  } finally {
    if (requestId === loadRequestId) loading.value = false
  }
}

watch(() => [section.value, isLoggedIn.value], loadSection, { immediate: true })
</script>
